import React, { useState, useEffect } from "react";
import {
  Card,
  CardContent,
  Typography,
  Grid,
  TextField,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  CircularProgress,
  Avatar,
  Box,
  InputLabel,
  Select,
  FormControl,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Checkbox,
 FormControlLabel
} from "@mui/material";
import { fontSize, GlobalStyles } from "@mui/system";
import { IconButton } from "@mui/material";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../AuthProvider";
import { useLocation } from "react-router-dom";

import { Menu, MenuItem, ListItemIcon, ListItemText } from "@mui/material";
import ExcelJS from "exceljs";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import FormHelperText from "@mui/material/FormHelperText";
import PaymentIcon from '@mui/icons-material/Payment';

import PresentToAllIcon from "@mui/icons-material/PresentToAll";
import SimCardDownloadIcon from "@mui/icons-material/SimCardDownload";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import FilePresentIcon from "@mui/icons-material/FilePresent";
import { useParams } from "react-router-dom";

const baseUrl = process.env.REACT_APP_API_BASE_URL;
function StudentPaymentList() {
  const { userId,oId,board,pId,feature,role } = useAuth();
   


     const navigate = useNavigate();
   const { admissionNumber } = useParams();
   const location = useLocation();
    // const { student } = location.state || {};
     const student = JSON.parse(sessionStorage.getItem("paymentListStudent"));

  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");
  const [transactionData, setTransactionData] = useState({});

    const [dialogOpen, setDialogOpen] = useState(false);
    const [selectedRowData, setSelectedRowData] = useState(null);
   
    const [selectedStudentId, setSelectedStudentId] = useState("");
    const [errors, setErrors] = useState({});

      const [users, setUsers] = useState([]);
      const [selectedUsers, setSelectedUsers] = useState("");
      // const isPrincipal = role?.startsWith("PRINCIPAL") || false;
      const UserId = userId || selectedUsers;
        const isPrincipal = role?.startsWith("PRINCIPAL") || false;

       const [open, setOpen] = useState(false);
       const [isConfirmed, setIsConfirmed] = useState(false);
//  const [editedData, setEditedData] = useState(null);
    // const [editedData, setEditedData] = useState({
    //     grandTotal: "",
    //     // totalPaid: "",
    //     feeDue: "",
    //     payMethod: "",
    //     paymentDate: "",
    //     transactionId: "",
    //     paymentAmount: "",
    //   });
    const [editedData, setEditedData] = useState({
  grandTotal: "",
  totalPaid: "",
  feeDue: "",
  payMethod: "",
  paymentDate: "",
  transactionId: "",
  paymentAmount: "",
});

 const fetchUsers = async () => {
      try {
        const response = await fetch(
          `${baseUrl}/api/principal/getAllUserIdsAndNames/ADMISSION_FEE/${oId}/${pId}`
        );
        if (!response.ok) {
          throw new Error("Failed to fetch users");
        }
        const data = await response.json();
        setUsers(data);
        if (data.length > 0) {
          setSelectedUsers(data[0].userId); // ✅ Set first record's userId as default
        }
      } catch (error) {
        console.error("Error fetching users:", error);
      }
    };
   useEffect(() => {
     if (isPrincipal) {
       fetchUsers();
     }
   }, []); // ✅ Only runs on mount 



    const fetchTableData = async () => {
      if (!admissionNumber) return;

      setLoading(true);
      try {
        const response = await fetch(
          `${baseUrl}/api/admission/getAllStudentsFeeDetailsAdmId/${admissionNumber}/${oId}/${pId}`
        );

        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }

        const data = await response.json();
        console.log("Fetched Data:", data);
        setTransactionData(data || {});
      } catch (error) {
        console.error("Error fetching fee details:", error);
        setTransactionData({});
      } finally {
        setLoading(false);
      }
    };

  useEffect(() => {
    fetchTableData();
  }, [admissionNumber, oId, pId, baseUrl]);

  // Convert nested object into an array for display
  const formattedTransactionData = [
    {
      category: "Admission Fee",
      Name: `${transactionData.admissionFeePaymentsDtos?.firstName || ""} ${transactionData.admissionFeePaymentsDtos?.lastName || ""}`,
      fatherName: `${transactionData.admissionFeePaymentsDtos?.fathersFirstName || ""} ${transactionData.admissionFeePaymentsDtos?.fathersLastName || ""}`,
      categoryType: transactionData.admissionFeePaymentsDtos?.rolePayment || "",
      total: transactionData.admissionFeePaymentsDtos?.totalFeePayments || 0,
      paid: transactionData.admissionFeePaymentsDtos?.totalFeePaid || 0,
      unpaid: transactionData.admissionFeePaymentsDtos?.totalFeeUnPaid || 0,
    },
    {
      category: "Tuition Fee",
      Name: `${transactionData.tutionFeePayDtos?.firstName || ""} ${transactionData.tutionFeePayDtos?.lastName || ""}`,
      fatherName: `${transactionData.tutionFeePayDtos?.fathersFirstName || ""} ${transactionData.tutionFeePayDtos?.fathersLastName || ""}`,
      categoryType: transactionData.tutionFeePayDtos?.rolePayment || "",
      total: transactionData.tutionFeePayDtos?.totalFeePayments || 0,
      paid: transactionData.tutionFeePayDtos?.totalFeePaid || 0,
      unpaid: transactionData.tutionFeePayDtos?.totalFeeUnPaid || 0,
    },

     ...((feature === "CORE" || feature === "ULTRA")? [
    {
      category: "Bus Fee",
      Name: `${transactionData.busFeePayDto?.firstName || ""} ${transactionData.busFeePayDto?.lastName || ""}`,
      fatherName: `${transactionData.busFeePayDto?.fathersFirstName || ""} ${transactionData.busFeePayDto?.fathersLastName || ""}`,
      categoryType: transactionData.busFeePayDto?.rolePayment || "",
      total: transactionData.busFeePayDto?.totalFeePayments || 0,
      paid: transactionData.busFeePayDto?.totalFeePaid || 0,
      unpaid: transactionData.busFeePayDto?.totalFeeUnPaid || 0,
    },
      ]: []), // Don't include 'Packages' if not ULTRA
    {
      category: "Exam Fee",
      Name: `${transactionData.examFeePaymentsDto?.firstName || ""} ${transactionData.examFeePaymentsDto?.lastName || ""}`,
      fatherName: `${transactionData.examFeePaymentsDto?.fathersFirstName || ""} ${transactionData.examFeePaymentsDto?.fathersLastName || ""}`,
      categoryType: transactionData.examFeePaymentsDto?.rolePayment || "",
      total: transactionData.examFeePaymentsDto?.totalFeePayments || 0,
      paid: transactionData.examFeePaymentsDto?.totalFeePaid || 0,
      unpaid: transactionData.examFeePaymentsDto?.totalFeeUnPaid || 0,
    },
     ...((feature === "CORE" || feature === "ULTRA")? [
    {
      category: "Hostel Fee",
      Name: `${transactionData.hostelFeePaymentsDto?.firstName || ""} ${transactionData.hostelFeePaymentsDto?.lastName || ""}`,
      fatherName: `${transactionData.hostelFeePaymentsDto?.fathersFirstName || ""} ${transactionData.hostelFeePaymentsDto?.fathersLastName || ""}`,
      categoryType: transactionData.hostelFeePaymentsDto?.rolePayment || "",
      total: transactionData.hostelFeePaymentsDto?.totalFeePayments || 0,
      paid: transactionData.hostelFeePaymentsDto?.totalFeePaid || 0,
      unpaid: transactionData.hostelFeePaymentsDto?.totalFeeUnPaid || 0,
    },
      ]: []), // Don't include 'Packages' if not ULTRA
    {
      category: "Additional Fee",
      Name: `${transactionData.additionalFeePaymentsDto?.firstName || ""} ${transactionData.additionalFeePaymentsDto?.lastName || ""}`,
      fatherName: `${transactionData.additionalFeePaymentsDto?.fathersFirstName || ""} ${transactionData.additionalFeePaymentsDto?.fathersLastName || ""}`,
      categoryType: transactionData.additionalFeePaymentsDto?.rolePayment || "",
      total: transactionData.additionalFeePaymentsDto?.totalFeePayments || 0,
      paid: transactionData.additionalFeePaymentsDto?.totalFeePaid || 0,
      unpaid: transactionData.additionalFeePaymentsDto?.totalFeeUnPaid || 0,
    },
    // {
    //   category: "Other Fee",
    // Name: transactionData.admissionFeePaymentsDtos?.firstName || "",
    //   fatherName: transactionData.admissionFeePaymentsDtos?.UMESH || "",
    //   categoryType: transactionData.otherPaymentsDtos?.rolePayment || "",
    //   total: transactionData.otherPaymentsDtos?.otherFeePayments || 0,
    //   paid: transactionData.otherPaymentsDtos?.otherFeePaid || 0,
    //   unpaid: transactionData.otherPaymentsDtos?.otherFeeUnPaid || 0,
    // },

  
  ];

  const handleEdit = (field, value) => {
      setEditedData((prev) => ({ ...prev, [field]: value }));
    };
  
    // const handleSave = async () => {
    //   // Validate required fields
    //   let newErrors = {};
  
    //   if (!editedData.paymentDate)
    //     newErrors.paymentDate = "Payment Date is required";
    //   // if (!editedData.transactionId)
    //   //   newErrors.transactionId = "Transaction ID is required";
    //   if (!editedData.paymentAmount)
    //     newErrors.paymentAmount = "Amount to be Paid is required";
    //   if (!editedData.payMethod)
    //     newErrors.payMethod = "Payment Method is required";
  
    //   // If there are errors, set them and return early
    //   if (Object.keys(newErrors).length > 0) {
    //     setErrors(newErrors);
    //     return;
    //   }
  
    //   setLoading(true);
    //   const UserId = userId || selectedUsers;
    //   try {
    //     // Prepare FormData
    //     const formData = new FormData();
    //     Object.entries(editedData).forEach(([key, value]) => {
    //       if (value !== null && value !== undefined) {
    //         formData.append(key, value);
    //       }
    //     });
  
    //     // Ensure sblId is explicitly sent as null (if required)
    //     formData.append("sblId", "0");
  
    //     // API request
    //     const response = await fetch(
    //       `${baseUrl}/api/transaction/save/${selectedStudentId}/${UserId}/${selectedRowData?.categoryType}/${student?.romanNumberClass}/${student?.sections}`,
    //       {
    //         method: "POST",
    //         body: formData,
    //       }
    //     );
  
    //     if (!response.ok) {
    //       const errorText = await response.text(); // Get detailed error response
    //       throw new Error(`${errorText}`);
    //     }
  
    //     // Success response
    //     toast.success("Payment saved successfully!", { autoClose: 1000 });
  
    //     // fetchGetAllTableData();
        
    //     if(board === "INTERMEDIATE") {
    //       // fetchCourseClassSectionTableData();
    //     }else{
    //       // fetchClassSectionTableData();
    //     }
    //     handlePayCloseDialog();
    //     setErrors({}); // Clear errors on successful submission
    //   } catch (error) {
    //     console.error("Error saving payment:", error);
    //     toast.error(`${error.message}`, {
    //       autoClose: 2000,
    //     });
    //   } finally {
    //     setLoading(false);
    //   }
    // };


    //total pay dialog box
  
  const handleSave = async () => {
  let newErrors = {};

  if (!editedData.paymentDate)
    newErrors.paymentDate = "Payment Date is required";
  if (!editedData.paymentAmount)
    newErrors.paymentAmount = "Amount to be Paid is required";
  if (!editedData.payMethod)
    newErrors.payMethod = "Payment Method is required";

  if (Object.keys(newErrors).length > 0) {
    setErrors(newErrors);
    return;
  }

  setLoading(true);
  const UserId = userId || selectedUsers;

  try {
    const formData = new FormData();

    // Append only dialog-related fields
    formData.append("paymentDate", editedData.paymentDate);
    formData.append("paymentAmount", editedData.paymentAmount);
    formData.append("payMethod", editedData.payMethod);
    formData.append("transactionId", editedData.transactionId);

   
    const response = await fetch(
      `${baseUrl}/api/transaction/save/${student?.studentId}/${UserId}/${selectedRowData?.categoryType}/${student?.romanNumberClass}/${student?.sections}`,
      {
        method: "POST",
        body: formData,
      }
    );

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(errorText);
    }

    toast.success("Payment saved successfully!", { autoClose: 1000 });

    fetchTableData();

    handlePayCloseDialog();
    setErrors({});
  } catch (error) {
    console.error("Error saving payment:", error);
    toast.error(`${error.message}`, { autoClose: 2000 });
  } finally {
    setLoading(false);
  }
};

  
  
    const today = new Date().toISOString().split("T")[0];
  const handleViewClick = (row) => {
    setSelectedRowData(row);
    // setSelectedStudentId(row.studentId);
    setEditedData({
      grandTotal: row.tutionFeePayments || "",
      totalPaid: row.tutionFeePaid || "",
      feeDue: row.tutionFeeUnPaid || "",
      payMethod: "Cash", // Default value
      paymentDate: today, // Default empty
      transactionId: "",
      fathersName: row.fathersName || "",
      firstName: row.firstName || "",
      lastName: row.lastName || "",
      romanNumberClass: row.romanNumberClass || "",
      sections: row.sections || "",
    });
    setDialogOpen(true);
  };

  const handlePayCloseDialog = () => {
    setDialogOpen(false); // Close the dialog
  };


  const handleOpenDialog = () => {
    setOpen(true);
    setIsConfirmed(false); // Reset on every open
  };

  const handleCloseDialog = () => {
    setOpen(false);
  };

  const handlePay = () => {
    if (isConfirmed) {
      console.log("Payment Proceeded");
      setOpen(false);
    } else {
      alert("Please confirm before proceeding.");
    }
  };

  const totalAmount = formattedTransactionData.reduce(
    (sum, row) => sum + (parseFloat(row.total) || 0),
    0
  );


  


  return (
    <Box sx={{ mt: "5%", mr: "1%", ml: "1%" }}>
    <Card
      style={{
        // margin: "60px 20px",
        padding: "10px",
        backgroundColor: "#ffffff",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
        borderRadius: "8px",
        // maxHeight: "100vh",
        // overflow: "hidden",
        width: "100%",
      }}
    >
      <CardContent>
         
        <Box display="flex" alignItems="center" sx={{ marginBottom: 2 }}>
          <IconButton onClick={() => navigate(-1)} sx={{ color: "#2e2a54" }}>
            <KeyboardBackspaceIcon fontSize="medium" />
          </IconButton>
          <Typography variant="h5" component="h3" sx={{ fontWeight: "bold" }}>
          <span style={{ color: "#757575", fontSize: "18px" }}>
            {student?.firstName || student?.lastName
              ? `${student?.firstName || ""} ${student?.lastName || ""}`.trim() + ""
              : "N/A "}
            </span> - {"All Payments List "}
          </Typography>
        </Box>

   

        <GlobalStyles
          styles={{
            ".custom-sidebar-scrollbar": {
              scrollbarWidth: "thin", // For Firefox
              scrollbarColor: "grey #e0e0e0",
            },
            ".custom-sidebar-scrollbar::-webkit-scrollbar": {
              width: "6px", // For WebKit-based browsers
            },
            ".custom-sidebar-scrollbar::-webkit-scrollbar-track": {
              background: "#f1f1f1", // Track color
            },
            ".custom-sidebar-scrollbar::-webkit-scrollbar-thumb": {
              backgroundColor: "grey", // Thumb color
              borderRadius: "10px",
            },
            ".custom-sidebar-scrollbar::-webkit-scrollbar-thumb:hover": {
              backgroundColor: "#555",
            },
          }}
        />

        {/* Table Section */}
        <TableContainer
          component={Paper}
          style={{
            marginTop: "20px",
            borderRadius: "8px",
            maxHeight: "800px",
            overflow: "auto",
            //  maxHeight: "800px",
            //   overflow: "auto",
          }}
          className="custom-sidebar-scrollbar"
        >
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell
                  sx={{
                    borderRight: "1px solid #ddd",
                    padding: "2px",
                    textAlign: "center",
                    backgroundColor: "#fff9c4",
                    fontWeight:'bold',
                    fontSize:'14px'
                  }}
                >
                  S.No
                </TableCell>
                <TableCell
                  sx={{
                    borderRight: "1px solid #ddd",
                    padding: "2px",
                    textAlign: "center",
                    backgroundColor: "#fff9c4",
                    fontWeight:'bold',
                    fontSize:'14px'
                  }}
                >
                  Category
                </TableCell>
               
               
                <TableCell
                  sx={{
                    borderRight: "1px solid #ddd",
                    padding: "2px",
                    textAlign: "center",
                    backgroundColor: "#fff9c4",
                    fontWeight:'bold',
                    fontSize:'14px'
                  }}
                >
                  Total Amount
                </TableCell>

                <TableCell
                  sx={{
                    borderRight: "1px solid #ddd",
                    padding: "2px",
                    textAlign: "center",
                    backgroundColor: "#fff9c4",
                    fontWeight:'bold',
                    fontSize:'14px'
                  }}
                >
                  Paid Amount
                </TableCell>
                <TableCell
                  sx={{
                    borderRight: "1px solid #ddd",
                    padding: "2px",
                    textAlign: "center",
                    backgroundColor: "#fff9c4",
                    fontWeight:'bold',
                    fontSize:'14px'
                  }}
                >
                  Unpaid Amount
                </TableCell>
                              <TableCell
                                  sx={{
                                    borderRight: "1px solid #ddd",
                                    padding: "4px",
                                    textAlign: "center",
                                    backgroundColor: "#fff9c4",
                                     fontWeight:'bold',
                                    fontSize:'14px'
                                  }}
                                >
                                  Payments
                                </TableCell>
                <TableCell
                  sx={{
                    borderRight: "1px solid #ddd",
                    padding: "2px",
                    textAlign: "center",
                    backgroundColor: "#fff9c4",
                    fontWeight:'bold',
                    fontSize:'14px'
                  }}
                >
                  Transactions
                </TableCell>

              </TableRow>
            </TableHead>

            <TableBody>
              {/* {!hasFetchedOnce || loading ? ( */}
              {loading ? (
                <TableRow>
                  <TableCell
                    colSpan={12}
                    style={{ textAlign: "center", padding: "20px" }}
                  >
                    <Box
                      display="flex"
                      flexDirection="column"
                      alignItems="center"
                    >
                      <CircularProgress />
                      <Typography variant="body2" sx={{ mt: 1 }}>
                        Loading Data...
                      </Typography>
                    </Box>
                  </TableCell>
                </TableRow>
              ) : formattedTransactionData.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={12} style={{ textAlign: "center" }}>
                    No data found.
                  </TableCell>
                </TableRow>
              ) : (
                <>
                {formattedTransactionData.map((row, index) => (
                  <TableRow
                    key={row.id}
                    style={{
                      backgroundColor: "white",
                      transition: "background-color 0.3s",
                      height: "30px", // Reduced row height
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = "#f5f5f5"; // Hover color
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = "white"; // Default color
                    }}
                  >
                    <TableCell
                      sx={{
                        textAlign: "center",
                        borderRight: "1px solid #ddd",
                        padding: "2px",
                      }}
                    >
                      {index + 1}
                    </TableCell>

                    <TableCell
                      sx={{
                        textAlign: "center",
                        borderRight: "1px solid #ddd",
                        padding: "2px",
                      }}
                    >
                      {row?.category}
                    </TableCell>
                   


                    
                    <TableCell
                      sx={{
                        textAlign: "center",
                        borderRight: "1px solid #ddd",
                        padding: "2px",
                      }}
                    >
                         ₹{row.total || "0"}
                    </TableCell>

                    <TableCell
                      sx={{
                        textAlign: "center",
                        borderRight: "1px solid #ddd",
                        padding: "2px",
                      }}
                    >
                        ₹{row.paid || "0"}
                    </TableCell>
                    <TableCell
                      sx={{
                        textAlign: "center",
                        borderRight: "1px solid #ddd",
                        padding: "2px",
                      }}
                    >
                     ₹{row.unpaid || "0"}
                    </TableCell>

                    <TableCell
                                          sx={{
                                            borderRight: "1px solid #ddd",
                                            padding: "4px",
                                            textAlign: "center",
                                          }}
                                        >
                                         
                                               {/* <Button
  type="button"
  onClick={() => handleViewClick(row)} // ✅ Pass the actual row
  disabled={row?.unpaid === 0} // Or use row.feeDue depending on your data field
  sx={{
    backgroundColor: row?.unpaid === 0 ? "#ccc" : "#1976d2",
    color: "white",
    fontSize: "0.7rem",
    height: "25px",
    "&:hover": {
      backgroundColor: row?.unpaid === 0 ? "#ccc" : "#1565c0",
    },
  }}
>
  Payments
</Button> */}
<Button
  type="button"
  onClick={() => handleViewClick(row)}
  disabled={row?.unpaid === 0 || row?.categoryType === "additional_fee"}
  sx={{
    backgroundColor:
      row?.unpaid === 0 || row?.categoryType === "additional_fee"
        ? "#ccc"
        : "#1976d2",
    color: "white",
    fontSize: "0.7rem",
    height: "25px",
    "&:hover": {
      backgroundColor:
        row?.unpaid === 0 || row?.categoryType === "additional_fee"
          ? "#ccc"
          : "#1565c0",
    },
  }}
>
  Payments
</Button>



                                        </TableCell>

                   
                   
                  <TableCell
  sx={{
    borderLeft: "1px solid #ddd",
    padding: "4px",
    textAlign: "center",
  }}
>
  <Button
    type="button"
     onClick={() => navigate(`/StudentPaymentsTransactionList/${admissionNumber}/${row.categoryType}`,
        {
        state: {
          CategoryType: row.categoryType,
        },
      })
    }
    disabled={!row.paid || row.paid <= 0} // ✅ disables if paid is 0 or undefined
    sx={{
    //   backgroundColor: "#1976d2",
     backgroundColor: row.paid === 0 ? "#ccc" : "#1976d2",
      color: "white",
      fontWeight: "bold",
      fontSize: "0.6rem",
      height: "25px",
      "&:hover": {
        // backgroundColor: "#1565c0",
         backgroundColor: row.paid === 0 ? "#ccc" : "#1565c0",
      },
    }}
  >
    View
  </Button>
</TableCell>

                  </TableRow>
                ))}
<TableRow
  style={{
    backgroundColor: "#f0f0f0",
    fontWeight: "bold",
    height: "30px",
  }}
>
  <TableCell
    sx={{
      textAlign: "center",
      borderRight: "1px solid #ddd",
      padding: "2px",
    }}
  >
    {/* Empty: below index column */}
  </TableCell>

  <TableCell
    sx={{
      textAlign: "center",
      borderRight: "1px solid #ddd",
      padding: "2px",
      fontWeight:'bold',
      fontSize:'14px'
    }}
  >
    {/* Empty or "Total" Label */}
    Total
  </TableCell>
  

  <TableCell
    sx={{
      textAlign: "center",
      borderRight: "1px solid #ddd",
      padding: "2px",
      fontWeight:'bold',
      fontSize:'14px'
    }}
  >
    ₹
    {formattedTransactionData.reduce(
      (sum, row) => sum + (parseFloat(row.total) || 0),
      0
    )}
  </TableCell>

  <TableCell
    sx={{
      textAlign: "center",
      borderRight: "1px solid #ddd",
      padding: "2px",
      fontWeight:'bold',
      fontSize:'14px'
    }}
  >
    ₹
    {formattedTransactionData.reduce(
      (sum, row) => sum + (parseFloat(row.paid) || 0),
      0
    )}
  </TableCell>

  <TableCell
    sx={{
      textAlign: "center",
      borderRight: "1px solid #ddd",
      padding: "2px",
      fontWeight:'bold',
      fontSize:'14px'
    }}
  >
    ₹
    {formattedTransactionData.reduce(
      (sum, row) => sum + (parseFloat(row.unpaid) || 0),
      0
    )}
  </TableCell>

  <TableCell
   sx={{
      borderLeft: "1px solid #ddd",
      padding: "2px",
      textAlign: "center",
    }}
    // sx={{
    //   borderRight: "1px solid #ddd",
    //   padding: "2px",
    //   textAlign: "center",
    //    display: "flex",
    // justifyContent: "center",
    // alignItems: "center", 
    // height: "100%", 
    // }}
  >


{/* <Button
  type="button"
  //  onClick={handleOpenDialog}
  sx={{
    background: "linear-gradient(to right, #4CAF50, #66BB6A)", // Green gradient
    color: "white", // Default text color
    fontSize: "0.8rem",
    fontWeight: 600,
    paddingX: 2.5,
    height: "32px",
    borderRadius: "20px",
    textTransform: "none",
    boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.2)",
    display: "flex",
    alignItems: "center",
    gap: "6px",
    "&:hover": {
      background: "linear-gradient(to right, #43A047, #388E3C)",
    },
  }}
>
 <Box
  component="span"
  sx={{
    color: "#ffffffff", // Deep Purple (or any color you prefer)
    fontWeight: "bold",
  }}
>
  Pay ₹{formattedTransactionData.reduce(
      (sum, row) => sum + (parseFloat(row.unpaid) || 0),
      0
    )}
</Box>


</Button> */}



  </TableCell>

  <TableCell
    sx={{
      borderLeft: "1px solid #ddd",
      padding: "2px",
      textAlign: "center",
    }}
  ></TableCell>
</TableRow>

</>
              )}
            </TableBody>
          </Table>
        </TableContainer>

        <Typography
  sx={{
    textAlign: "right",
    paddingTop: "10px",
    paddingRight: "20px",
    fontWeight: "bold",
  }}
>
  Total Amount To Pay : 
  <Typography component="span" sx={{ fontSize: "19px", fontWeight: "bold" }}>
    ₹{formattedTransactionData.reduce(
      (sum, row) => sum + (parseFloat(row.unpaid) || 0),
      0
    )}
  </Typography>
</Typography>


 {/* Dialog Box */}
        <Dialog
          open={dialogOpen}
          onClose={handlePayCloseDialog}
          fullWidth
          maxWidth="sm"
          sx={{ borderRadius: 3 }}
        >
          <DialogTitle
            sx={{
              fontWeight: "bold",
              textAlign: "center",
              bgcolor: "#1976d2",
              color: "white",
              py: 2,
              borderTopLeftRadius: 3,
              borderTopRightRadius: 3,
            }}
          >
             {selectedRowData ? `${selectedRowData.category} Payment` : 'Payment'}
          </DialogTitle>
          <DialogContent>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 2,
                p: "20px",
              }}
            >
              <div style={{ display: "flex", width: "100%" }}>
                <div style={{ display: "flex", width: "100%" }}>
                  <span style={{ fontWeight: "bold", paddingRight: "10px" }}>
                    Student Name:
                  </span>
                  <span>
                    {selectedRowData?.Name}
                  </span>
                </div>
                <div style={{ display: "flex", width: "100%" }}>
                  <span style={{ fontWeight: "bold", paddingRight: "15px" }}>
                    Father Name:
                  </span>
                  {selectedRowData?.fatherName}
                </div>
              </div>

              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <TextField
                    label="Total Fee"
                    variant="outlined"
                    value={`₹${selectedRowData?.total}`}
                    fullWidth
                    size="small"
                    disabled
                    InputProps={{
                      style: {
                        backgroundColor: "#f0f0f0",
                        color: "#6c757d",
                        fontWeight: "bold",
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    label="Paid Amount"
                    variant="outlined"
                    value={`₹${selectedRowData?.paid || "No Paid Amount"}`}
                    fullWidth
                    size="small"
                    disabled
                    InputProps={{
                      style: {
                        backgroundColor: "#f0f0f0",
                        color: "#6c757d",
                        fontWeight: "bold",
                      },
                    }}
                  />
                </Grid>
              {/* </Grid> */}
              {/* <Grid container spacing={2}> */}
                <Grid item xs={6}>
                  <TextField
                    label="Due Amount"
                    variant="outlined"
                    value={`₹${selectedRowData?.unpaid || "No Fee Due Amount"}`}
                    fullWidth
                    size="small"
                    disabled
                    InputProps={{
                      style: {
                        backgroundColor: "#f0f0f0",
                        color: "#6c757d",
                        fontWeight: "bold",
                      },
                    }}
                  />
                </Grid>

             
              <Grid item xs={6}>
                <TextField
                  label="Payment Date"
                  variant="outlined"
                  type="date"
                  value={editedData.paymentDate }
                  onChange={(e) =>
                    handleEdit("paymentDate", e.target.value)
                  }
                  fullWidth
                  size="small"
                  InputLabelProps={{ shrink: true }}
                  inputProps={{
                    max: new Date().toISOString().split("T")[0], // ✅ No future dates
                  }}
                />
              </Grid>
              

                <Grid item xs={6}>
<TextField
  label="Amount to be Paid"
  variant="outlined"
  type="text"
  value={editedData.paymentAmount}
  placeholder="Enter Amount"
  onKeyDown={(e) => {
    // Allow only digits and control keys like Backspace, Delete, Arrow keys
    const allowedKeys = [
      "Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab"
    ];
    if (
      !/^\d$/.test(e.key) && // if not a digit
      !allowedKeys.includes(e.key)
    ) {
      e.preventDefault(); // Block the key press
    }
  }}
  onChange={(e) => {
    const val = e.target.value;
    if (/^\d*$/.test(val)) {
      handleEdit("paymentAmount", val);
      setErrors({ ...errors, paymentAmount: "" });
    }
  }}
  fullWidth
  size="small"
  error={!!errors.paymentAmount}
  helperText={errors.paymentAmount}
  inputProps={{
    inputMode: "numeric",
    maxLength: 10,
  }}
/>



                </Grid>
                <Grid item xs={6}>
                  <TextField
                    label="Transaction Id"
                    variant="outlined"
                    value={editedData.transactionId}
                    onChange={(e) => {
                      handleEdit("transactionId", e.target.value);
                    //   setErrors({ ...errors, transactionId: "" });
                    }}
                    fullWidth
                    size="small"
                  />
                </Grid>

                <Grid item xs={6}>
                  <FormControl
                    fullWidth
                    size="small"
                    error={!!errors.payMethod}
                  >
                    <InputLabel>Payment Method</InputLabel>
                    <Select
                      value={editedData.payMethod}
                      onChange={(e) => {
                        handleEdit("payMethod", e.target.value);
                        setErrors({ ...errors, payMethod: "" });
                      }}
                      label="Payment Method"
                    >
                      <MenuItem value="Cash">Cash</MenuItem>
                      <MenuItem value="Credit">Credit Card</MenuItem>
                      <MenuItem value="Debit">Debit</MenuItem>
                      <MenuItem value="Online">Online</MenuItem>
                    </Select>
                    {errors.payMethod && (
                      <FormHelperText>{errors.payMethod}</FormHelperText>
                    )}
                  </FormControl>
                </Grid>

              </Grid>
            </Box>
          </DialogContent>
          <DialogActions
            sx={{ justifyContent: "flex-end", pt: 0.5, pb: 1, pr: 2 }}
          >
            <Button
              onClick={handlePayCloseDialog}
              color="primary"
              variant="outlined"
            >
              Cancel
            </Button>
            <Button
              onClick={handleSave}
              color="success"
              variant="outlined"
              sx={{
                backgroundColor: "#3C3972",
                color: "white",
                fontSize: "0.8rem",
                height: "35px",
                minWidth: "80px", // Ensures consistent button size
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                "&:hover": {
                  backgroundColor: "#3C3972",
                },
              }}
              disabled={loading} // Disable button while loading
            >
              {loading ? (
                <CircularProgress size={20} sx={{ color: "white" }} />
              ) : (
                "Save"
              )}
            </Button>
          </DialogActions>
        </Dialog>



         {/* Dialog */}
      <Dialog open={open} onClose={handleCloseDialog}>
        <DialogTitle>Confirm Payment</DialogTitle>
        <DialogContent>
          <FormControlLabel
            control={
              <Checkbox
                checked={isConfirmed}
                onChange={(e) => setIsConfirmed(e.target.checked)}
              />
            }
            label="I confirm I want to proceed with the payment"
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} color="secondary">
            Cancel
          </Button>
          <Button
            onClick={handlePay}
            variant="contained"
            color="success"
            disabled={!isConfirmed}
          >
            Proceed to Pay
          </Button>
        </DialogActions>
      </Dialog>

   <ToastContainer position="top-right" autoClose={1000} />
      </CardContent>
    </Card>
    </Box>
  );
}

export default StudentPaymentList;